import { ApolloClient, ApolloLink, HttpLink } from '@apollo/client';
import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import { Auth } from '@chocolate-soup-inc/cs-api-consumer-utils';
import { AUTH_TYPE, AuthOptions, createAuthLink } from 'aws-appsync-auth-link';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';
import { cache } from './cache';

const url = import.meta.env.REACT_APP_API_URL as string;
const region = import.meta.env.REACT_APP_REGION as string;
const isProd = import.meta.env.REACT_APP_STAGE?.toLowerCase() == 'production';

const authOptions: AuthOptions = {
  type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
  jwtToken: () => {
    return Auth.currentSession().then((session) => {
      return session.getAccessToken().getJwtToken();
    });
  }
};

const httpLink = new HttpLink({ uri: url });

const link = ApolloLink.from([
  createAuthLink({
    url,
    region,
    auth: authOptions
  }),
  createSubscriptionHandshakeLink(
    {
      url,
      region,
      auth: authOptions
    },
    httpLink
  )
]);

if (import.meta.env.REACT_APP_STAGE != 'production') {
  loadDevMessages();
  loadErrorMessages();
}

export const client = new ApolloClient({
  link,
  cache,
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache'
    }
  },
  devtools: {
    enabled: !isProd
  }
});
